import React, {useState} from "react";

export const RfmSettingRowBuilder = (props) => {
    const [rows,setRows]=useState([1,2,3,4,5]);
    const firstRow=()=>{
        return(
        <tr>
            <th scope="row"  className={"text-primary font-weight-bold"}>1</th>
            <td>
                <div>
                    <span>بیشتر و مساوی از </span>
                    <input type="text"  onChange={props.change} className={"form-control text-center font-weight-bold"} value={`${props.setting["score1_r_from"]}`} type={"score1_r_from"} />
                </div>
            </td>
            <td>
                <div>
                    <span>کمتر از </span>
                    <input type="text"   onChange={props.change} className={"form-control text-center font-weight-bold"} value={`${props.setting["score1_f_from"]}`} type={"score1_f_from"}/>
                </div>
            </td>
            <td>
                <div>
                    <span>کمتر از </span>
                    <input type="text"  onChange={props.change} className={"form-control text-center font-weight-bold"} value={`${props.setting["score1_m_from"]}`} type={"score1_m_from"}/>
                </div>
            </td>
        </tr>
    )}
    const lastRow=()=>{
        return(
        <tr>
            <th scope="row"  className={"text-primary font-weight-bold"}>5</th>
            <td>
                <div>
                    <span>کمتر از </span>
                    <input type="text"  onChange={props.change} className={"form-control text-center font-weight-bold"} value={`${props.setting["score5_r_to"]}`} type={"score5_r_to"} />
                </div>
            </td>
            <td>
                <div>
                <span>بیشتر و مساوی از </span>
                    <input type="text"   onChange={props.change} className={"form-control text-center font-weight-bold"} value={`${props.setting["score5_f_to"]}`}type={"score5_f_to"} />
                </div>
            </td>
            <td>
                <div>
                <span>بیشتر و مساوی از </span>
                    <input type="text"   onChange={props.change} className={"form-control text-center font-weight-bold"} value={`${props.setting["score5_m_to"]}`} type={"score5_m_to"} />
                </div>
            </td>
        </tr>
    )}
    const row=(score)=>{
        let fieldRF="score"+score+"_r_from";
        let fieldFF="score"+score+"_f_from";
        let fieldMF="score"+score+"_m_from";
        let fieldRT="score"+score+"_r_to";
        let fieldFT="score"+score+"_f_to";
        let fieldMT="score"+score+"_m_to";

        return (
        <tr className={"text-center"}>
            <th scope="row" className={"text-primary font-weight-bold"}>{score}</th>
            <td>
                <div className={"my-2"}>
                <span>بیشتر و مساوی از </span>

                    <input type="text" className={"form-control text-center font-weight-bold "}  onChange={props.change} value={`${props.setting[fieldRF]}`} type={fieldRF}/>
                </div>
                <div className={"my-2"}>
                    <span>کمتر از </span>

                    <input type="text" className={"form-control text-center font-weight-bold"}  onChange={props.change} value={`${props.setting[fieldRT]}`} type={fieldRT} />
                </div>
            </td>
            <td>
                <div className={"my-2"}>
                <span>بیشتر و مساوی از </span>

                    <input type="text" className={"form-control text-center font-weight-bold"}  onChange={props.change}  value={`${props.setting[fieldFF]}`} type={fieldFF} />
                </div>
                <div className={"my-2"}>
                    <span>کمتر از </span>

                    <input type="text" className={"form-control text-center font-weight-bold"}   onChange={props.change} value={`${props.setting[fieldFT]}`} type={fieldFT} />
                </div>
            </td>
            <td>
                <div className={"my-2"}>
                <span>بیشتر و مساوی از </span>

                    <input type="text" className={"form-control text-center font-weight-bold"}   onChange={props.change} value={`${props.setting[fieldMF]}`} type={fieldMF}/>
                </div>
                <div className={"my-2"}>
                    <span>کمتر از </span>

                    <input type="text" className={"form-control text-center font-weight-bold"} onChange={props.change} value={`${props.setting[fieldMT]}`} type={fieldMT}/>
                </div>
            </td>
        </tr>
    )}
    return (
        <>
            {console.log(props)}
             {
                 rows.map((value, index, array)=>{
                     return(
                         <>
                             {value==1 && firstRow()}
                             {value==5 && lastRow()}
                             {value!=1 && value!=5 && row(value)}
                         </>
                     )
                 })
              }
        </>
    )
}
